module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "m-2",
    attrs: {
      "model": _vm.info,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": "shop_img"
    }
  }, [_c('image-uploader', {
    model: {
      value: (_vm.info.shop_img),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_img", $$v)
      },
      expression: "info.shop_img"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "景点名",
      "prop": "shop_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "景点名"
    },
    model: {
      value: (_vm.info.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_name", $$v)
      },
      expression: "info.shop_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简介",
      "prop": "shop_intro"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "一句话介绍你的群（最长14个字符）"
    },
    model: {
      value: (_vm.info.shop_intro),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_intro", $$v)
      },
      expression: "info.shop_intro"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "shop_description"
    }
  }, [_c('wang-editor', {
    model: {
      value: (_vm.info.shop_description),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_description", $$v)
      },
      expression: "info.shop_description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "shop_type"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.info.shop_type),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_type", $$v)
      },
      expression: "info.shop_type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 6,
      "label": "景点"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "shop_phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "景点电话"
    },
    model: {
      value: (_vm.info.shop_phone),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_phone", $$v)
      },
      expression: "info.shop_phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "shop_address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "景点地址"
    },
    model: {
      value: (_vm.info.shop_address),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_address", $$v)
      },
      expression: "info.shop_address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间",
      "prop": "shop_business_time"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "营业时间"
    },
    model: {
      value: (_vm.info.shop_business_hour),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_business_hour", $$v)
      },
      expression: "info.shop_business_hour"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "shop_status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.info.shop_status),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_status", $$v)
      },
      expression: "info.shop_status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("审核")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("上线")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("下线")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function () { return _vm.$router.back(); }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a708810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/view/view-edit.vue
// module id = 786
// module chunks = 1